<mat-card class="m-card about-views">
  <mat-card-title class="m-title">
    <span class="m-header">About eZintegrations</span>
  </mat-card-title>
  <mat-card-content class="m-body">
    <p>eZintegrations™ is a browser-based cloud data integration platform that does real-time data integration with minimum IT intervention for connecting any enterprise application. By leveraging eZintegrations™ no-code iPaaS, users can connect data from fragmented sources and empower organizations to consolidate multiple cloud solutions into a single platform. It can integrate any system traditional RDBMS, NoSQL, Cloud Databases, Data Warehouse, Data Lake, REST API, SOAP API or logs, videos, voice notes or stats from Linux commands as well as various protocols from IoT sensors.</p>

    <div class="about-views-video">
      <iframe height="315" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
    </div>

    <p>Connect any on-premise enterprise application from all leading vendors such as cloud and SAP, Oracle, Infor, Workdays, Salesforce, Snowflake, NetSuite, or any other enterprise application.</p>

    <p>Connect and manage master data of customers, suppliers, products, and assets directly from your MDM application. Enhance your items and assets with GTIN, URN, EIDR, UUID, UDI, or any other identifier.</p>

    <p>Connect your business with your extended partners and 3PL. Transact data efficiently with full compliance and complete security.</p>

    <p>Manage SaaS applications in the cloud for all sizes of enterprises. Automate data transactions, notifications, workflows, and Robotic Process Automation (RPA) flows.</p>

    <p>Connect & bring in real-time data from digital marketing platforms, social media metrics, SaaS and enterprise data applications to enterprise data warehouse.</p>

    <p>Connect and manage reviews, comments, and preferences of your end customers. Manage and analyze insights, engagement, following, and ad metrics.</p>

    <p>Integrate application notifications, workflows, important object views, and alerts from all of your enterprise applications right to your mobile device.</p>
  </mat-card-content>
</mat-card>
